import { AdminAuthProvider, useAdminAuth } from './contexts/AdminAuthContext'
import { AdminLogin } from './pages/AdminLogin'
import { AdminDashboard } from './pages/AdminDashboard'

const AdminAppInner: React.FC = () => {
  const { isAuthenticated, isLoading } = useAdminAuth()

  if (isLoading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-lg text-gray-600">Loading...</div>
      </div>
    )
  }

  return isAuthenticated ? <AdminDashboard /> : <AdminLogin />
}

function AdminApp() {
  return (
    <AdminAuthProvider>
      <AdminAppInner />
    </AdminAuthProvider>
  )
}

export default AdminApp
